import { render, staticRenderFns } from "./CompetitionSort.vue?vue&type=template&id=01d81c18&scoped=true"
import script from "./CompetitionSort.vue?vue&type=script&lang=js"
export * from "./CompetitionSort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d81c18",
  null
  
)

export default component.exports